module.exports = __webpack_public_path__ + "static/image2-6067fa591b06995fe6a6b20e62ec2c12.png";